export const RESET = 'CONDITION_UPDATE_RESET'
export const SET_ERROR = 'CONDITION_UPDATE_SET_ERROR'
export const SET_RETRIEVED = 'CONDITION_UPDATE_SET_RETRIEVED'
export const SET_UPDATED = 'CONDITION_UPDATE_SET_UPDATED'
export const SET_VIOLATIONS = 'CONDITION_UPDATE_SET_VIOLATIONS'
export const TOGGLE_LOADING = 'CONDITION_UPDATE_TOGGLE_LOADING'
export const UPDATE_RETRIEVED = 'CONDITION_UPDATE_UPDATE_RETRIEVED'
export const SET_FILES = 'CONDITION_UPDATE_FILES'
